/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import MetaTags from 'react-meta-tags'
import { Row, Col, Alert, Container } from 'reactstrap'

// action
import { apiError } from '../../store/actions'

//redux
import { useDispatch } from 'react-redux'

// import images
import logo from '../../assets/images/xero/logo-blue.png'
import {
  getXeroTenants,
  updateXeroAuthtoken,
} from '../../helpers/lopay_api_helper'
import { XeroConnection } from '../../api-dtos/xero/xero.dto'
import {
  accountingAccessErrorCode,
  accountingAccessErrorMessage,
  readStoredAccess,
} from 'src/helpers/accounting-access/accounting-access'

interface PageProps {
  google: Object
  history: any
  match: {
    params: {}
  }
}

const REOPEN_FROM_APP_MESSAGE = accountingAccessErrorMessage(
  'link_invalid',
  'Xero',
)

const XeroConnected = ({ history }: PageProps) => {
  const dispatch = useDispatch()

  const [selectedTenantId, setSelectedTenantId] = useState<string | undefined>()
  const [xeroConnections, setXeroConnections] = useState<
    XeroConnection[] | undefined
  >()

  const [error, setError] = useState<string | null>()
  const [loading, setLoading] = useState<boolean>(true)

  // Xero returns its tokens in the query; the merchant and our own signed
  // access were kept in session storage before the consent redirect.
  const queryParams = new URLSearchParams(window.location.search)
  const idToken = queryParams.get('xero_idtoken')
  const authToken = queryParams.get('xero_authtoken')
  const refresh = queryParams.get('xero_refresh')
  const sessionState = queryParams.get('xero_sessionState')
  const access = readStoredAccess('xero')

  const showAccessError = (e: unknown) => {
    const code = accountingAccessErrorCode(e)
    setError(
      code
        ? accountingAccessErrorMessage(code, 'Xero')
        : 'Something went wrong connecting to Xero. Please try again from the Lopay app.',
    )
  }

  const listXeroConnections = async () => {
    if (!access) {
      setError(REOPEN_FROM_APP_MESSAGE)
      return
    }

    if (!idToken || !authToken || !refresh || !sessionState) {
      setError('Could not retrieve a code from Xero. Please try again.')
      return
    }

    setLoading(true)

    try {
      setXeroConnections(
        await getXeroTenants(access.merchantId, access.credentials, authToken),
      )
    } catch (e) {
      showAccessError(e)
    }
  }

  const updateXeroToken = async (tenantId: string) => {
    if (!access) {
      setError(REOPEN_FROM_APP_MESSAGE)
      return
    }

    if (!idToken || !authToken || !refresh || !sessionState) {
      setError('Could not retrieve a code from Xero. Please try again.')
      return
    }

    setLoading(true)

    try {
      await updateXeroAuthtoken(
        access.merchantId,
        access.credentials,
        idToken,
        authToken,
        refresh,
        sessionState,
        tenantId,
      )

      history.push(`/xero/${access.merchantId}`)
    } catch (e) {
      showAccessError(e)
    }
  }

  const handleValidSubmit = () => {
    window.location.href = 'https://lopay.com/download'
  }

  useEffect(() => {
    dispatch(apiError(''))
    listXeroConnections().then(() => setLoading(false))
  }, [dispatch])

  return (
    <React.Fragment>
      <MetaTags>
        <title>Connect Xero | Lopay</title>
      </MetaTags>
      <div className="auth-page">
        <Container fluid className="p-0">
          <Row className="g-0">
            <Col lg={6} md={6} className="col-xxl-3">
              <div className="auth-full-page-content d-flex p-sm-5 p-4">
                <div className="w-100">
                  <div className="d-flex flex-column h-100">
                    <div className="mb-4 mb-md-5 text-center">
                      <img src={logo} alt="" height="100" />{' '}
                    </div>
                    <div className="auth-content my-auto">
                      <div className="text-center">
                        <h5 className="mb-0">Xero // Lopay</h5>
                        <p className="text-muted mt-2">
                          Select which Xero account to connect to Lopay
                        </p>
                      </div>
                      <form className="needs-validation custom-form mt-4 pt-2">
                        {error ? <Alert color="danger">{error}</Alert> : null}

                        {!error && !xeroConnections && loading && (
                          <>Loading Xero accounts...</>
                        )}

                        {!error && xeroConnections && loading && (
                          <>Connecting...</>
                        )}

                        {!error && !selectedTenantId && !loading && (
                          <ul className="list-group list-group-flush">
                            {xeroConnections?.map((tenant) => {
                              return (
                                <button
                                  key={tenant.tenantId}
                                  type="button"
                                  className="btn btn-primary btn-lg waves-effect waves-light"
                                  onClick={(e) => {
                                    e.preventDefault()
                                    setSelectedTenantId(tenant.tenantId)
                                    updateXeroToken(tenant.tenantId).then(() =>
                                      setLoading(false),
                                    )
                                  }}
                                >
                                  Connect to {tenant.tenantName}
                                </button>
                              )
                            })}
                          </ul>
                        )}
                        {selectedTenantId && (
                          <div className="mb-3">
                            <button
                              disabled={loading}
                              className="btn btn-primary w-100 waves-effect waves-light"
                              type="button"
                              onClick={() => {
                                handleValidSubmit()
                              }}
                            >
                              {loading ? `Loading...` : `Go back to Lopay`}
                            </button>
                          </div>
                        )}
                      </form>
                    </div>
                    <div className="mt-4 mt-md-5 text-center">
                      <p className="mb-0">
                        © {new Date().getFullYear()} Lopay . Crafted with{' '}
                        <i className="mdi mdi-heart text-danger"></i> by Lopay
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default XeroConnected
